import StoreDetails from 'components/store/storeDetails';

const SotreDetailsPage = () => {
  return <StoreDetails />;
};

export default SotreDetailsPage;
